import { c as _c } from "react/compiler-runtime";
import { Eye, EyeOff } from "lucide-react";
import { useEffect, useState } from "react";
import { BrandCardHeader } from "#/components/brand/BrandCardHeader";
import { Button } from "#/components/ui/button";
import { Card, CardContent } from "#/components/ui/card";
import { Input } from "#/components/ui/input";
import { LoadingButton } from "#/components/ui/loading-button";
import { Separator } from "#/components/ui/separator";
import { StatusMessage } from "#/components/ui/status-message";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function StatusMessageCard(t0) {
  const $ = _c(10);
  const {
    statusMessage,
    onStatusMessageAction
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(BrandCardHeader, {
      title: "Logga in",
      subtitle: "Logga in med ditt Faster Forward-konto"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = statusMessage.variant === "confirmation" ? "p-6" : undefined;
  let t3;
  if ($[1] !== statusMessage.message || $[2] !== statusMessage.variant || $[3] !== t2) {
    t3 = /*#__PURE__*/_jsx(StatusMessage, {
      message: statusMessage.message,
      variant: statusMessage.variant,
      className: t2
    });
    $[1] = statusMessage.message;
    $[2] = statusMessage.variant;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onStatusMessageAction) {
    t4 = /*#__PURE__*/_jsx(Button, {
      onClick: onStatusMessageAction,
      className: "w-full",
      children: "Forts\xE4tt till inloggning"
    });
    $[5] = onStatusMessageAction;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = /*#__PURE__*/_jsxs(Card, {
      className: "bg-card m-auto w-screen overflow-y-auto rounded-none shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
      children: [t1, /*#__PURE__*/_jsx(CardContent, {
        className: "p-6",
        children: /*#__PURE__*/_jsxs("div", {
          className: "space-y-4",
          children: [t3, t4]
        })
      })]
    });
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function PasswordInput(t0) {
  const $ = _c(11);
  const {
    showPassword,
    onTogglePassword
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx("label", {
      htmlFor: "password",
      className: "block text-sm font-medium",
      children: "L\xF6senord"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = showPassword ? "text" : "password";
  let t3;
  if ($[1] !== t2) {
    t3 = /*#__PURE__*/_jsx(Input, {
      id: "password",
      name: "password",
      type: t2,
      required: true
    });
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== showPassword) {
    t4 = showPassword ? /*#__PURE__*/_jsx(EyeOff, {
      className: "h-4 w-4 text-gray-400"
    }) : /*#__PURE__*/_jsx(Eye, {
      className: "h-4 w-4 text-gray-400"
    });
    $[3] = showPassword;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onTogglePassword || $[6] !== t4) {
    t5 = /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onTogglePassword,
      className: "absolute inset-y-0 right-0 flex items-center pr-3",
      children: t4
    });
    $[5] = onTogglePassword;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t1, /*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [t3, t5]
      })]
    });
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function GoogleSignInButton(t0) {
  const $ = _c(3);
  const {
    signInWithGoogle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsxs("svg", {
      className: "mr-2 h-5 w-5",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z",
        fill: "#4285F4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z",
        fill: "#34A853"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z",
        fill: "#FBBC05"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z",
        fill: "#EA4335"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1 1h22v22H1z",
        fill: "none"
      })]
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== signInWithGoogle) {
    t2 = /*#__PURE__*/_jsxs(Button, {
      variant: "outline",
      className: "w-full",
      onClick: signInWithGoogle,
      children: [t1, "Logga in med Google"]
    });
    $[1] = signInWithGoogle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function SignInFooter(t0) {
  const $ = _c(8);
  const {
    onRegisterClick,
    onForgotPasswordClick,
    signUpEnabled: t1
  } = t0;
  const signUpEnabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== onRegisterClick || $[1] !== signUpEnabled) {
    t2 = signUpEnabled && /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Har du inget konto?", " ", /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onRegisterClick,
        className: "text-primary hover:underline",
        children: "Registrera dig"
      })]
    });
    $[0] = onRegisterClick;
    $[1] = signUpEnabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onForgotPasswordClick) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: "mt-2",
      children: /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onForgotPasswordClick,
        className: "text-primary hover:underline",
        children: "Gl\xF6mt ditt l\xF6senord?"
      })
    });
    $[3] = onForgotPasswordClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = /*#__PURE__*/_jsxs("div", {
      className: "mt-4 text-center text-sm",
      children: [t2, t3]
    });
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export default function SignInCard(t0) {
  const $ = _c(38);
  const {
    handleLogin,
    onRegisterClick,
    onForgotPasswordClick,
    statusMessage,
    onStatusMessageAction,
    isLoading,
    signUpEnabled: t1,
    signInWithGoogle
  } = t0;
  const signUpEnabled = t1 === undefined ? true : t1;
  const [showPassword, setShowPassword] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      message: "",
      success: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [loginState, setLoginState] = useState(t2);
  let t3;
  let t4;
  if ($[1] !== statusMessage) {
    t3 = () => {
      if (statusMessage) {
        setLoginState({
          message: "",
          success: false
        });
      }
    };
    t4 = [statusMessage];
    $[1] = statusMessage;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== handleLogin) {
    t5 = async e => {
      e.preventDefault();
      const formData = new FormData(e.currentTarget);
      const email = formData.get("email");
      const password = formData.get("password");
      try {
        const response = await handleLogin(email, password);
        setLoginState({
          success: response.success,
          message: response.message
        });
      } catch {
        setLoginState({
          success: false,
          message: "Ett fel uppstod vid inloggning. F\xF6rs\xF6k igen."
        });
      }
    };
    $[4] = handleLogin;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const onSubmit = t5;
  if (statusMessage) {
    let t6;
    if ($[6] !== onStatusMessageAction || $[7] !== statusMessage) {
      t6 = /*#__PURE__*/_jsx(StatusMessageCard, {
        statusMessage: statusMessage,
        onStatusMessageAction: onStatusMessageAction
      });
      $[6] = onStatusMessageAction;
      $[7] = statusMessage;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    return t6;
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /*#__PURE__*/_jsx(BrandCardHeader, {
      title: "Logga in",
      subtitle: "Logga in med ditt Faster Forward-konto"
    });
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== signInWithGoogle) {
    t7 = /*#__PURE__*/_jsx(GoogleSignInButton, {
      signInWithGoogle: signInWithGoogle
    });
    $[10] = signInWithGoogle;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /*#__PURE__*/_jsx("div", {
      className: "absolute inset-0 flex items-center",
      children: /*#__PURE__*/_jsx(Separator, {
        className: "w-full"
      })
    });
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = /*#__PURE__*/_jsx("div", {
      className: "my-6",
      children: /*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [t8, /*#__PURE__*/_jsx("div", {
          className: "relative flex justify-center text-xs uppercase",
          children: /*#__PURE__*/_jsx("span", {
            className: "bg-background text-muted-foreground px-2",
            children: "Eller"
          })
        })]
      })
    });
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: "email",
        className: "block text-sm font-medium",
        children: "E-post"
      }), /*#__PURE__*/_jsx(Input, {
        id: "email",
        name: "email",
        type: "email",
        required: true
      })]
    });
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== showPassword) {
    t11 = () => setShowPassword(!showPassword);
    $[15] = showPassword;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== showPassword || $[18] !== t11) {
    t12 = /*#__PURE__*/_jsx(PasswordInput, {
      showPassword: showPassword,
      onTogglePassword: t11
    });
    $[17] = showPassword;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== loginState.message || $[21] !== loginState.success) {
    t13 = loginState.message && /*#__PURE__*/_jsx(StatusMessage, {
      message: loginState.message,
      variant: loginState.success ? "success" : "error"
    });
    $[20] = loginState.message;
    $[21] = loginState.success;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== isLoading) {
    t14 = /*#__PURE__*/_jsx(LoadingButton, {
      type: "submit",
      className: "w-full",
      loading: isLoading,
      children: "Logga in"
    });
    $[23] = isLoading;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== onForgotPasswordClick || $[26] !== onRegisterClick || $[27] !== signUpEnabled) {
    t15 = /*#__PURE__*/_jsx(SignInFooter, {
      onRegisterClick: onRegisterClick,
      onForgotPasswordClick: onForgotPasswordClick,
      signUpEnabled: signUpEnabled
    });
    $[25] = onForgotPasswordClick;
    $[26] = onRegisterClick;
    $[27] = signUpEnabled;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== onSubmit || $[30] !== t12 || $[31] !== t13 || $[32] !== t14 || $[33] !== t15) {
    t16 = /*#__PURE__*/_jsxs("form", {
      onSubmit: onSubmit,
      className: "space-y-4",
      children: [t10, t12, t13, t14, t15]
    });
    $[29] = onSubmit;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16 || $[36] !== t7) {
    t17 = /*#__PURE__*/_jsxs(Card, {
      className: "bg-card m-auto w-screen overflow-y-auto rounded-none shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
      children: [t6, /*#__PURE__*/_jsxs(CardContent, {
        className: "p-6",
        children: [t7, t9, t16]
      })]
    });
    $[35] = t16;
    $[36] = t7;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
}